import React from 'react';
import '../../styles/home.css'
import profileImg from '../../images/profile.png'
import backgroundImg from '../../images/backgrond-circle-removebg-preview.png'
import { useSelector } from 'react-redux';
import { Button } from '../../componetns';
import { Link } from 'react-scroll'
import CV from '../../images/cv.pdf';
import { FaLinkedinIn, FaInstagram, FaFacebookF, FaGithub } from "react-icons/fa";
const Home = () => {
  const { isDark } = useSelector((state) => state.useReducer);
  const viewCV = () => {
    window.open(CV, '_blank');
  }
  return (
    <div className='home-main' style={{ backgroundColor: `${isDark ? "#070F2B" : "#fff"}` }} name="/">
      <div className='container' >
        <div className='row' >
          <div className='col-12 col-lg-8 profile-div'>
            <div id='float-icons-main'>
              <div><FaGithub className='fload-social-icon' onClick={() => window.open('https://github.com/Muneshkumar12/', "_blank")} /><span className="name">Github</span></div>
              <div><FaLinkedinIn className='fload-social-icon' onClick={() => window.open("https://www.linkedin.com/in/munesh-kumar-1b8860289/", "_blank")} /><span className="name">Linkedin</span></div>
              <div><FaInstagram className='fload-social-icon' onClick={() => window.open("https://www.instagram.com/munesh_kumar3/", "_blank")} /><span className="name">instagram</span></div>
              <div><FaFacebookF className='fload-social-icon' onClick={() => window.open("https://www.facebook.com/profile.php?id=100069228849518", "_blank")} /><span className="name">Facebook</span></div>
            </div>
            <img src={profileImg} alt='profile' style={{ boxShadow: "#3F51B5 0px 5px 15px" }} />
          </div>
          <div className='col-12 col-lg-4 profile-data' >
            <h1 style={{ color: "#3F51B5" }}>Frontend web & wordpress developer</h1>
            <p style={{ color: `${isDark ? "#fff" : "#000"}` }}>Hi, I’m Munesh Kumar, a Front-End Web Developer specializing in building
              modern, responsive, and user-friendly websites. I focus on creating
              clean interfaces using HTML, CSS, JavaScript, and Bootstrap, along with
              custom WordPress solutions that help businesses grow online.
            </p>
            <div>
              <Link to="contact"><Button title="Hire Me" /></Link>
              <Button title="View CV" onClick={viewCV} />
            </div>
          </div>
        </div>
        <div className='page-header-circle'>
          <img src={backgroundImg} alt='circle' />
        </div>
      </div>
    </div>
  )
}
export default Home;